import { USER_REFRESH_TIME } from '@/configs/constants';
// import { UNREAD_TYPE } from '@/schemas/common';
import * as services from '@services/index';

interface IState {
  totalUnread: number;
}

const im = {
  state: {
    totalUnread: 0,
    pollingFrequency: USER_REFRESH_TIME // 查询所有未读消息轮训评率
    // totalUserUnread: 0,
    // totalDoctorUnread: 0
  },

  reducers: {
    updateState(state, payload) {
      return {
        ...state,
        ...payload
      };
    }
  },

  effects: (_dispath) => ({
    async getAllUnread() {
      const result = await services.im.getAllUnread();
      // console.log('---model unread', result, (new Date()).getSeconds())
      this.updateState({
        totalUnread: result.unreadCount,
        pollingFrequency: result.pollingFrequency
      });
    }
  })
};

export default im;
